import { createContext } from 'react';
var RendererContext = createContext({
  formOptions: {}
});
export default RendererContext;